import { Component, ChangeDetectionStrategy, inject, computed, output, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@gains-com/ui-angular';
import { PromotionsView } from '../../../../core/view-states/promotions-view.service.js';

@Component({
  selector: 'app-purchase-boost-banner',
  templateUrl: './purchase-boost-banner.component.html',
  styleUrl: './purchase-boost-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class PurchaseBoostBannerComponent {
  private readonly _promotionsView = inject(PromotionsView);

  fullWidth = input<boolean>(false);
  includeInfoIcon = input<boolean>(true);

  /** Emitted when FTP banner is clicked to show the detail view */
  readonly openDetails = output<void>();

  boost = toSignal(this._promotionsView.activePurchaseBoost$);

  bannerText = computed(() => {
    const boost = this.boost();
    if (!boost) {
      return '';
    }

    if (boost.isFirstTimePurchaseBoost) {
      return 'FIRST TIME BOOST ACTIVATED';
    }

    return `${boost.percentage}% GAINS BOOST ACTIVATED`;
  });
}
